module.exports = __webpack_public_path__ + "img/315.075181fe.jpg";